<template>
  <div class="content-center none-click">
    <div class="banner">
      <img src="@/assets/Mobile/images/solution/cashier-banner.png" alt="">
    </div>
    <div class="block01">
      <div class="sk-mobile-title">
        <div class="title">智能收银一体化解决方案</div>
      </div>
      <img src="@/assets/Mobile/images/solution/cashier01.png" alt="">
    </div>
    <div class="block02">
      <div class="sk-mobile-title">
        <div class="title">线下门店经营场景</div>
      </div>
      <img src="@/assets/Mobile/images/solution/cashier02.png" alt="">
    </div>
    <div class="block03">
      <div class="sk-mobile-title">
        <div class="title">产品优势</div>
      </div>
      <img src="@/assets/Mobile/images/solution/cashier03.png" alt="">
    </div>
    <div class="block04">
      <div class="sk-mobile-title">
        <div class="title">特色服务</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/cashier04.png" alt="">
          <span>海量商品库<br>快速添加商品</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/cashier05.png" alt="">
          <span>串码管理<br>3C行业个性化需求</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/cashier06.png" alt="">
          <span>粉丝分组<br>精准营销</span>
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/cashier07.png" alt="">
          <span>挂单取单快速结账<br>线上订单门店提醒</span>
        </div>
      </div>
    </div>
    <IndustrySolution />
    <div class="block06">
      <div class="sk-mobile-title">
        <div class="title">支持多款硬件设备</div>
        <div class="sub-title">智能收银只出售软件，且软件适配多款市场主流硬件设备，<br>推荐如下精选设备</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/Mobile/images/solution/device01.png" alt="">
          SUNMI T2
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/device02.png" alt="">
          SUNMI T2 LIT
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/device03.png" alt="">
          SUNMI D2
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/device04.png" alt="">
          扫码枪
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/device05.png" alt="">
          多品牌24v钱箱
        </div>
        <div class="item">
          <img src="@/assets/Mobile/images/solution/device06.png" alt="">
          佳博票据打印机
        </div>
      </div>
    </div>
    <Case title="智能收银" />

    <ContactForm info-sources="智能收银" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import ContactForm from '@/Mobile/Mobilecom/ContactForm'
import IndustrySolution from '@/Mobile/Mobilecom/IndustrySolution'
import Case from '@/Mobile/Mobilecom/Case'

export default {
  metaInfo: metaInfo.Cashier,
  components: {
    ContactForm,
    IndustrySolution,
    Case
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  height: 200px;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
.block01 {
  background-color: #FAFAFA;
  img {
    width: 337px;
    margin: 21px 0 18px 0;
  }
}
.block02 {
  background-color: #F1F4FF;
  img {
    width: 342px;
    margin: 13px 0 17px 0;
  }
}
.block03 {
  background-color: #FAFAFA;
  img {
    width: 340px;
    margin: 22px 0;
  }
}
.block04 {
  .content {
    padding-top: 20px;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        width: 296px;
      }
      span {
        font-size: 14px;
        font-weight: 500;
        color: #595961;
        line-height: 20px;
        margin: 15px 0 30px 0;
      }
    }
  }
}
.block06 {
  .content {
    padding: 24px 0 14px 0;
    display: flex;
    width: 375px;
    flex-wrap: wrap;
    justify-content: space-evenly;
    .item {
      margin-top: 7px;
      display: flex;
      flex-direction: column;
      // margin: 15px;
      font-size: 6px;
      line-height: 16px;
      color: #000000;
    }
    img {
      width: 106px;
      height: 52px;
    }
  }
}
</style>
